import axios from 'axios';

// Określ baseURL w zależności od środowiska
const getBaseURL = () => {
  // Jeśli jest ustawiona zmienna środowiskowa, użyj jej (priorytet)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // W środowisku deweloperskim użyj proxy (względny URL)
  // Proxy w package.json przekieruje /api na http://localhost:4000/api
  if (process.env.NODE_ENV === 'development') {
    return '/api';
  }
  
  // Dla produkcji - użyj domyślnego URL backendu z Render
  // Możesz nadpisać ustawiając REACT_APP_API_URL w Vercel
  return 'https://socialagent-w8gq.onrender.com/api';
};

// Axios instance z konfiguracją
const api = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor - dodaj token do każdego requestu
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - obsługa błędów
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token wygasł - wyloguj użytkownika
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const register = (email, password, companyName) => 
  api.post('/auth/register', { email, password, companyName });

export const login = (email, password) => 
  api.post('/auth/login', { email, password });

export const getMe = () => 
  api.get('/auth/me');

export const getIndustries = () => 
  api.get('/auth/industries');

export const initAdmin = () => 
  api.post('/auth/init');

// Data Sources
export const getDataSources = () => 
  api.get('/data-sources');

export const getDataSource = (id) => 
  api.get(`/data-sources/${id}`);

export const createDataSource = (data) => 
  api.post('/data-sources', data);

export const updateDataSource = (id, data) => 
  api.put(`/data-sources/${id}`, data);

export const deleteDataSource = (id) => 
  api.delete(`/data-sources/${id}`);

export const testDataSource = (id) => 
  api.post(`/data-sources/${id}/test`);

// Templates
export const getTemplates = () => 
  api.get('/templates');

export const getTemplate = (id) => 
  api.get(`/templates/${id}`);

export const createTemplate = (data) => 
  api.post('/templates', data);

export const updateTemplate = (id, data) => 
  api.put(`/templates/${id}`, data);

export const deleteTemplate = (id) => 
  api.delete(`/templates/${id}`);

// Posts
export const getPosts = (page = 1, limit = 20, status = null) => {
  const params = { page, limit };
  if (status) params.status = status;
  return api.get('/posts', { params });
};

export const getPost = (id) => 
  api.get(`/posts/${id}`);

export const deletePost = (id) => 
  api.delete(`/posts/${id}`);

// Schedule
export const getSchedules = () => 
  api.get('/schedule');

export const getSchedule = (id) => 
  api.get(`/schedule/${id}`);

export const createSchedule = (data) => 
  api.post('/schedule', data);

export const updateSchedule = (id, data) => 
  api.put(`/schedule/${id}`, data);

export const deleteSchedule = (id) => 
  api.delete(`/schedule/${id}`);

// Dashboard
export const getDashboardStats = () => 
  api.get('/dashboard/stats');

export const getDashboardActivity = (limit = 10) => 
  api.get('/dashboard/activity', { params: { limit } });

// Generator
export const previewPost = (sourceId, templateId) => 
  api.post('/generator/preview', { sourceId, templateId });

export const publishPost = (data) => 
  api.post('/generator/publish', data);

// WordPress
export const connectWordPress = (domain, username, applicationPassword) =>
  api.post('/integrations/wordpress/connect', { domain, username, applicationPassword });

export const getWordPressStatus = () =>
  api.get('/integrations/wordpress/status');

export const disconnectWordPress = () =>
  api.post('/integrations/wordpress/disconnect');

export const getWordPressPosts = (page = 1, per_page = 20, search = '', status = 'publish') =>
  api.get('/wordpress/posts', { params: { page, per_page, search, status } });

export const getWordPressPost = (id) =>
  api.get(`/wordpress/posts/${id}`);

export const publishWordPressPost = (postId, platforms) =>
  api.post(`/wordpress/posts/${postId}/publish`, { platforms });

// YouTube
export const saveYouTubeSettings = (apiKey) =>
  api.post('/integrations/settings/youtube', { apiKey });

export const testYouTubeConnection = (apiKey = null) =>
  api.post('/integrations/youtube/test', apiKey ? { apiKey } : {});

// RSS
export const testRSSFeed = (url) =>
  api.post('/integrations/rss/test', { url });

export default api;

